import React, { PureComponent } from 'react'
import appUrl, { imageUrl } from '@libs/appUrl'
import getSecretColor from '@libs/getSecretColor'
import ReactHtmlParser from 'react-html-parser'

import { compose, withTranslation } from '@hocs'
import { withRNApp } from '@libs/RNApp'

import Carousel from '@components/Carousel'

import { StyledPostImageBlock } from './PostImageBlock.styled'

class PostImageBlock extends PureComponent {
  static defaultProps = {
    isApp: false,
    className: '',
    secretColor: getSecretColor(),
    carousel: [],
    title: '',
    text: '',
    t: () => false,
  }

  getImg = ({ path = '', thumb = '' }) => imageUrl((this.props.isApp ? thumb : path) || '')

  getHref = ({ path = '' }) => `${appUrl.imgUrl}${path || ''}`

  render() {
    const { secretColor, carousel = [], title, text, editorType, noShaper, children } = this.props
    const isSlick = carousel[0]?.path

    return (
      <StyledPostImageBlock className="PostImageBlock">
        <div className="wrapper">
          {isSlick ? (
            <Carousel images={carousel} editorType={editorType} noShaper={noShaper} />
          ) : (
            <div className="content" style={{ backgroundColor: secretColor }}>
              {title && <h1>{title}</h1>}
              {text && <p>{ReactHtmlParser(text)}</p>}
            </div>
          )}
        </div>
        {children}
      </StyledPostImageBlock>
    )
  }
}

export default compose(withTranslation(), withRNApp)(PostImageBlock)
